

export default function (variables = {}) {
  // 查找是否存在指定的style标签
  let styleTag = document.querySelector('style#root-css-variables');

  // 如果不存在，则创建一个新的style标签
  if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.id = 'root-css-variables';
      document.head.appendChild(styleTag);
      // 初始化根节点的CSS变量
      styleTag.innerHTML = ':root {}';
  }
  // 获取style标签中的根节点规则
  let rootRule = null;
  for (let rule of styleTag.sheet.cssRules) {
      if (rule.selectorText === ':root') {
          rootRule = rule;
          break;
      }
  }

  // 如果没有找到根节点规则，则创建一个新的
  if (!rootRule) {
      styleTag.sheet.insertRule(':root {}', 0);
      rootRule = styleTag.sheet.cssRules[0];
  }

  // 批量更新或添加CSS变量
  for (const [variableName, variableValue] of Object.entries(variables)) {
      rootRule.style.setProperty(variableName, variableValue);
  }
  
}